import { ReactElement } from 'react';

export const LAYOUT_CONST = {
  VERTICAL_LAYOUT: 'vertical',
  HORIZONTAL_LAYOUT: 'horizontal',
  DEFAULT_DRAWER: 'default',
  MINI_DRAWER: 'mini-drawer'
};

export const LAYOUT: any = {
  main: 'main',
  noauth: 'noauth',
  minimal: 'minimal'
};
export interface Props {
  children: ReactElement;
  variant?: 'main' | 'minimal' | 'noauth';
}
export default LAYOUT;

export type TwilioPhoneCountry = 'US' | 'CA';

export type AreaCodeGroup = {
  country: TwilioPhoneCountry;
  region: string;
  codes: string[];
};

export const AREA_CODES: AreaCodeGroup[] = [
  { country: 'US', region: 'Alabama', codes: ['205', '251', '256', '334', '659', '938'] },
  { country: 'US', region: 'Alaska', codes: ['907'] },
  { country: 'US', region: 'Arizona', codes: ['480', '520', '602', '623', '928'] },
  { country: 'US', region: 'Arkansas', codes: ['479', '501', '870'] },
  {
    country: 'US',
    region: 'California',
    codes: [
      '209',
      '213',
      '279',
      '310',
      '323',
      '341',
      '350',
      '408',
      '415',
      '424',
      '442',
      '510',
      '530',
      '559',
      '562',
      '619',
      '626',
      '628',
      '650',
      '657',
      '661',
      '669',
      '707',
      '714',
      '747',
      '760',
      '805',
      '818',
      '820',
      '831',
      '840',
      '858',
      '909',
      '916',
      '925',
      '949',
      '951'
    ]
  },
  { country: 'US', region: 'Colorado', codes: ['303', '719', '720', '970', '983'] },
  { country: 'US', region: 'Connecticut', codes: ['203', '475', '860', '959'] },
  { country: 'US', region: 'Delaware', codes: ['302'] },
  {
    country: 'US',
    region: 'Florida',
    codes: [
      '239',
      '305',
      '321',
      '352',
      '386',
      '407',
      '448',
      '561',
      '656',
      '689',
      '727',
      '754',
      '772',
      '786',
      '813',
      '850',
      '863',
      '904',
      '941',
      '954'
    ]
  },
  { country: 'US', region: 'Georgia', codes: ['229', '404', '470', '478', '678', '706', '762', '770', '912', '943'] },
  { country: 'US', region: 'Hawaii', codes: ['808'] },
  { country: 'US', region: 'Idaho', codes: ['208', '986'] },
  { country: 'US', region: 'Illinois', codes: ['217', '224', '309', '312', '331', '447', '464', '618', '630', '708', '773', '779', '815', '847', '872'] },
  { country: 'US', region: 'Indiana', codes: ['219', '260', '317', '463', '574', '765', '812', '930'] },
  { country: 'US', region: 'Iowa', codes: ['319', '515', '563', '641', '712'] },
  { country: 'US', region: 'Kansas', codes: ['316', '620', '785', '913'] },
  { country: 'US', region: 'Kentucky', codes: ['270', '364', '502', '606', '859'] },
  { country: 'US', region: 'Louisiana', codes: ['225', '318', '337', '504', '985'] },
  { country: 'US', region: 'Maine', codes: ['207'] },
  { country: 'US', region: 'Maryland', codes: ['240', '301', '410', '443', '667'] },
  { country: 'US', region: 'Massachusetts', codes: ['339', '351', '413', '508', '617', '774', '781', '857', '978'] },
  { country: 'US', region: 'Michigan', codes: ['231', '248', '269', '313', '517', '586', '616', '734', '810', '906', '947', '989'] },
  { country: 'US', region: 'Minnesota', codes: ['218', '320', '507', '612', '651', '763', '952'] },
  { country: 'US', region: 'Mississippi', codes: ['228', '601', '662', '769'] },
  { country: 'US', region: 'Missouri', codes: ['314', '417', '557', '573', '636', '660', '816'] },
  { country: 'US', region: 'Montana', codes: ['406'] },
  { country: 'US', region: 'Nebraska', codes: ['308', '402', '531'] },
  { country: 'US', region: 'Nevada', codes: ['702', '725', '775'] },
  { country: 'US', region: 'New Hampshire', codes: ['603'] },
  { country: 'US', region: 'New Jersey', codes: ['201', '551', '609', '640', '732', '848', '856', '862', '908', '973'] },
  { country: 'US', region: 'New Mexico', codes: ['505', '575'] },
  {
    country: 'US',
    region: 'New York',
    codes: [
      '212',
      '315',
      '332',
      '347',
      '363',
      '516',
      '518',
      '585',
      '607',
      '631',
      '646',
      '680',
      '716',
      '718',
      '838',
      '845',
      '914',
      '917',
      '929',
      '934'
    ]
  },
  { country: 'US', region: 'North Carolina', codes: ['252', '336', '472', '704', '743', '828', '910', '919', '980', '984'] },
  { country: 'US', region: 'North Dakota', codes: ['701'] },
  { country: 'US', region: 'Ohio', codes: ['216', '220', '234', '326', '330', '380', '419', '440', '513', '567', '614', '740', '937'] },
  { country: 'US', region: 'Oklahoma', codes: ['405', '539', '572', '580', '918'] },
  { country: 'US', region: 'Oregon', codes: ['458', '503', '541', '971'] },
  {
    country: 'US',
    region: 'Pennsylvania',
    codes: ['215', '223', '267', '272', '412', '445', '484', '570', '582', '610', '717', '724', '814', '835', '878']
  },
  { country: 'US', region: 'Rhode Island', codes: ['401'] },
  { country: 'US', region: 'South Carolina', codes: ['803', '839', '843', '854', '864'] },
  { country: 'US', region: 'South Dakota', codes: ['605'] },
  { country: 'US', region: 'Tennessee', codes: ['423', '615', '629', '731', '865', '901', '931'] },
  {
    country: 'US',
    region: 'Texas',
    codes: [
      '210',
      '214',
      '254',
      '281',
      '325',
      '346',
      '361',
      '409',
      '430',
      '432',
      '469',
      '512',
      '682',
      '713',
      '726',
      '737',
      '806',
      '817',
      '830',
      '832',
      '903',
      '915',
      '936',
      '940',
      '945',
      '956',
      '972',
      '979'
    ]
  },
  { country: 'US', region: 'Utah', codes: ['385', '435', '801'] },
  { country: 'US', region: 'Vermont', codes: ['802'] },
  { country: 'US', region: 'Virginia', codes: ['276', '434', '540', '571', '703', '757', '804', '826', '948'] },
  { country: 'US', region: 'Washington', codes: ['206', '253', '360', '425', '509', '564'] },
  { country: 'US', region: 'Washington, DC', codes: ['202', '771'] },
  { country: 'US', region: 'West Virginia', codes: ['304', '681'] },
  { country: 'US', region: 'Wisconsin', codes: ['262', '414', '534', '608', '715', '920'] },
  { country: 'US', region: 'Wyoming', codes: ['307'] },
  {
    country: 'CA',
    region: 'Ontario',
    codes: ['226', '249', '289', '343', '365', '416', '437', '519', '548', '613', '647', '683', '705', '742', '753', '807', '905']
  },
  { country: 'CA', region: 'Quebec', codes: ['354', '367', '418', '438', '450', '468', '514', '579', '581', '819', '873'] },
  { country: 'CA', region: 'British Columbia', codes: ['236', '250', '257', '604', '672', '778'] },
  { country: 'CA', region: 'Alberta', codes: ['368', '403', '587', '780', '825'] },
  { country: 'CA', region: 'Manitoba', codes: ['204', '431', '584'] },
  { country: 'CA', region: 'Saskatchewan', codes: ['306', '474', '639'] },
  { country: 'CA', region: 'Nova Scotia', codes: ['782', '902'] },
  { country: 'CA', region: 'New Brunswick', codes: ['428', '506'] },
  { country: 'CA', region: 'Newfoundland and Labrador', codes: ['709', '879'] },
  { country: 'CA', region: 'Prince Edward Island', codes: ['782', '902'] },
  { country: 'CA', region: 'Northern Territories (YT/NT/NU)', codes: ['867'] }
];

export const getAreaCodeCountry = (code: string): TwilioPhoneCountry =>
  AREA_CODES.find((g) => g.codes.includes(code))?.country ?? 'US';
